import strengthenQuestionConstants from '../constants/strengthenQuestionConstants';

const initialState = {
  oldAccount: true,
  strengthenQuestions: {},
};

const strengthenQuestionReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case strengthenQuestionConstants.GET_STRENGTHEN_QUESTION:
      return {
        ...state,
        oldAccount: action.payload.old_account,
        strengthenQuestions: action.payload.strength_questions_data,
      };
    default:
      return state;
  }
};

export default strengthenQuestionReducer;
